const prod = {
  baseURL: process.env.REACT_APP_API_URL,

  apiURL: process.env.REACT_APP_URL,
};

const dev = {
  baseURL: process.env.REACT_APP_API_URL,

  apiURL: process.env.REACT_APP_URL,
};

export const config = process.env.NODE_ENV === `development` ? dev : prod;
